import React from 'react';

const ITEMS = [
  'Software Development India','Digital Marketing Agency India','Web Development Company',
  'Mobile App Development India','SEO Services India','Custom Software India',
  'UI/UX Design India','Best IT Company India','MERN Stack Developers','React.js Experts India',
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="ticker-wrap" aria-hidden="true">
      <div className="ticker">
        {doubled.map((item, i) => (
          <span key={i} className="ticker-item">
            {item}<span className="t-sep"/>
          </span>
        ))}
      </div>
    </div>
  );
}
